var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height"},[_c('case-detail-sidebar'),_c('case-detail-summary',{staticClass:"pl-10 overflow-y",staticStyle:{"height":"84vh","overflow-x":"hidden"},attrs:{"files":_vm.files}}),_c('case-detail-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }